module.exports = __webpack_public_path__ + "img/白芷.ae1d93ae.jpg";